jQuery(document).ready(function($) {    

  	//FAQ on click hide/show animation
    
  	$(".faq_section").click(function (f) {
      var currfaq = $(f);
    
         $(".faq_section").each(function(e) {
           if ($(e) !== currfaq){
             $(e).removeClass('active');
             console.log('nf');
           }
         })
        if( $(this).hasClass('active'))
          { $(this).removeClass('active');} 
        else {$(this).addClass('active');}
  	});
  });